import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { NgModule, ErrorHandler } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule }    from "@angular/common/http";

import * as Raven from "raven-js";

import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";

import { environment } from "../environments/environment";

const sentryDsn = (environment.sentryDsn) ? environment.sentryDsn : null;
if (sentryDsn) {
	Raven
		.config(sentryDsn)
		.install();
}

export class RavenErrorHandler implements ErrorHandler {
	handleError(err:any) : void {
		Raven.captureException(err);
	}
}

const routes: Routes = [
	{
		path: "signup",
		data: { showMock: false },
		loadChildren: "app/signup/signup.module#SignupModule"
	},
	{
		path: "setup",
		data: { showMock: true },
		loadChildren: "app/wizard/wizard.module#WizardModule"
	},
		{
		path: "**",
		pathMatch: "full",
		redirectTo: "signup",
	}
];

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		SharedModule,
		RouterModule.forRoot(routes)
	],
	providers: environment.sentryDsn ? [ { provide: ErrorHandler, useClass: RavenErrorHandler } ] : [],
	bootstrap: [AppComponent]
})
export class AppModule { }
